<template>
  <l-layout :layout="['xs12']">
        <v-card>
          <l-data-table
            ref="blackVehicleList"
          :headers="header"
          search-text="搜索车辆"
          :filter-items="filterItems"
            clickable
            @click:row="getDetails($event.item)"
          :get-data-func="getBlackList">
            <template slot="title">
              <span class="pl-2 pr-4">冻结车辆管理（当前{{amount}}辆）</span>
            </template>
            <template slot="row-action" slot-scope="{item}">
              <td @click.stop>
                <v-tooltip bottom>
                  <v-btn slot="activator" icon @click="unFreezeVehicle(item)" >
                    <v-icon small>mdi-lock</v-icon>
                  </v-btn>
                  <span>解除冻结</span>
                </v-tooltip>
              </td>
            </template>
          </l-data-table>
          <l-fixed-btn
            @click="addBlackVehicle"
            icon="$vuetify.icons.add"
          ></l-fixed-btn>
        </v-card>
  </l-layout>
</template>
<script>
import LDataTable from '../../ladmin/components/LDataTable/LDataTable'
import {time} from '../../ladmin/utils/time'
export default {
  name: 'blackList',
  components: {LDataTable},
  data () {
    return {
      index: 1,
      amount: 0,
      header: [
        {text: '车辆号牌', align: 'left', value: 'objectId', sortable: false},
        {text: '预约人', align: 'left', value: 'applicantName', sortable: false, f: v => v || 'N/A'},
        {text: '预约人二级单位', align: 'left', value: 'applicantOrgName', sortable: false,
          f: (v, item) => v || item.applicantOrgId || 'N/A'},
        {text: '个人/单位预约', align: 'left', value: 'orderType', sortable: false,
          f: v => v === 'order_object' ? '个人预约' : v === 'order_group' ? '单位预约' : 'N/A'},
        {text: '登记类型', align: 'left', value: 'registerType', sortable: false},
        {text: '联系方式', align: 'left', value: 'phone', sortable: false},
        {text: '操作人', align: 'left', value: 'creator', sortable: false},
        {text: '到期时间', align: 'left', value: 'fetime', sortable: false, f: (v) => time.stringify(v)},
        {text: '添加时间', align: 'left', value: 'creationTime', f: (v) => time.stringify(v)},
        {text: '冻结说明', value: 'comment', align: 'left', maxWidth: '28em', tooltip: true},
        {text: '', align: 'left', value: '', sortable: false}
      ],
      filterItems: [
        {
          key: 'creationTime',
          value: {},
          label: '登记时间',
          type: 'duration',
          layout: ['xs12', 'sm4'],
          f: v => v ? [time.toTimeStamp(v.startDatetime) || 0, time.toTimeStamp(v.endDatetime) || 9999999999999] : [0, 9999999999999],
          range: true
        },
        {
          key: 'applicantOrgId',
          value: '',
          label: '预约人二级单位',
          type: 'select',
          items: [{text: '全部', value: ''}],
          layout: ['xs12', 'sm4'],
        }
      ],
    }
  },
  methods: {
    async getBlackList ({pagination, sortStack, filterItems = [], search}) {
      const duration = filterItems.find(item => item.key === 'creationTime')
      const org = filterItems.find(item => item.key === 'applicantOrgId')
      const period = duration && duration.value || {}
      let searchParam = {
        plateNumber: search || '',
        orgId: org && org.value || '',
        startTime: period.startDatetime ? time.toTimeStamp(period.startDatetime) : null,
        endTime: period.endDatetime ? time.toTimeStamp(period.endDatetime) : null
      }
      let res = await this.$store.dispatch('passControl/getBlackList', {pagination: pagination, searchParam: searchParam})
      if (res.data.status === 1) {
        this.amount = res.data.data.totalElements
        return {items: res.data.data.content, amount: res.data.data.totalElements}
      }
      else {
        this.$L.alert('error', {message: '查询失败，原因：' + res.data.msg})
      }
    },
    async loadOrganizations () {
      const options = [{text: '全部', value: ''}]
      const size = 200
      for (let page = 1; ; page++) {
        const res = await this.$store.dispatch('userAdmin/getOrgListByName', {
          pagination: {page, rowsPerPage: size}, name: '', id: '', type: 'org'
        })
        if (res.data.status !== 1) throw new Error(res.data.msg || '查询单位失败')
        const data = res.data.data
        options.push(...data.content.map(org => ({text: org.name, value: org.id})))
        if (page * size >= data.totalElements || !data.content.length) break
      }
      this.filterItems.find(item => item.key === 'applicantOrgId').items = options
    },
    async unFreezeVehicle (item) {
      let {res, close} = await this.$L.confirm({title: '提示', text: '您确定要解冻该车辆？'})
      if (res) {
        try {
          let searchParam = {
            'fstime': '',
            'fetime': '',
            'objectId': item.objectId
          }
          let res = await this.$store.dispatch('passControl/unFreezeVehicle', {plateNumber: item.objectId, searchParam: searchParam})
          if (res.data.status === 1) {
            this.$L.alert('success', {message: '解冻成功'})
            this.$refs.blackVehicleList.refresh()
          }
          else {
            this.$L.alert('error', {message: '解冻失败，原因：' + res.data.msg})
          }
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    addBlackVehicle () {
      this.$router.push({
        name: 'blackVehicle',
        query: {
          id: this.index++
        }
      })
    },
    getDetails (item) {
      console.log(item)
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({
          name: 'VehicleStatisticDetails',
          params: {
            plate: item.objectId,
          },
        })
      }
    }
  },
  created () {
    this.loadOrganizations().catch(() => {
      this.$L.alert('error', {message: '单位列表加载失败'})
    })
  }
}
</script>
